<div
  class="badge-container sm-leading-none {{ size }} {{ type }} {{ theme }} {{ customClasses }}"
  [class.sm-opacity-50]="disabled">
  <i *ngIf="icon" [ngClass]="'cc-icon cc-icon-' + icon" aria-hidden="true"></i>
  <div [ngClass]="textSize" class="font" [class.sm-font-medium]="bold">{{ text }}</div>
</div>
